import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/css/normalize.scss'
import './assets/css/common.scss'

import { post } from './plugins/http'
import api from './utils/api'
import dayjs from './plugins/dayjs'
import utils from './plugins/utils.js'
import { i18nTranslateInit } from '@/utils/utility-lang'
import echarts from './plugins/echarts'
import components from './plugins/components'
import adaptive from './plugins/adaptive'
import mixin from './plugins/mixin.js'
import theme from './theme'
import mount from './utils/mount'

import digitjs from './plugins/digitjs'
digitjs.colour({ up: theme['--up-color'], down: theme['--down-color'], flat: 'inherit' })

Vue.use(dayjs)
Vue.use(utils)
Vue.use(echarts)
Vue.use(components)
Vue.use(adaptive)
Vue.use(mixin)

Vue.prototype.$post = post
Vue.prototype.$api = api
Vue.prototype.$digitjs = digitjs
Vue.prototype.$t = i18nTranslateInit.t
Vue.prototype.$i18n = i18nTranslateInit

Vue.config.productionTip = false

const vm = new Vue({
  router,
  store,
  provide() {
    return {
      theme
    }
  },
  render: (h) => h(App)
})

mount(vm)
